import { defineComponent as _defineComponent } from 'vue'
import {
  Modal,
  InitialAvatarIcon,
  Heading,
  BaseText,
  ButtonBoxDecide
} from '@warrenbrasil/nebraska-web';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { tradeModule } from '@/modules/trade/store/trade';
import { computed } from 'vue';
import { useRouter, useRoute } from 'vue-router/composables';
import type { IPixRequestMessage } from '@/modules/cash/views/Deposit/types.ts';
import { moneyFormat } from '@/modules/common/helpers/currency';
import { FeatureFlagsModule } from '@/modules/common/store/FeatureFlagsModule';
import { FeatureFlags } from '@/types/models/FeatureFlags';

interface Props {
  isOpenModal: boolean;
  messageData: IPixRequestMessage['message'] | null;
}

interface Emits {
  (event: 'on-close'): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PixSectionModal',
  props: {
    isOpenModal: { type: Boolean },
    messageData: null
  },
  emits: ["on-close"],
  setup(__props: any, { emit: emits }: { emit: ({
  (event: 'on-close'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  isOpenModal: boolean;
  messageData: IPixRequestMessage['message'] | null;
};





const router = useRouter();
const route = useRoute();

const isMarketAvailable = computed(
  () => tradeModule.tradeStatus?.marketAvailable?.isMarketAvailable
);

const transformCurrencyAmount = computed(() => {
  if (!props.messageData?.amount) return null;
  return moneyFormat(props.messageData.amount as number);
});

const shouldShowInvestmentFlowButtons = computed(() => {
  return route.params.cameFrom;
});

return { __sfc: true,props, emits, router, route, isMarketAvailable, transformCurrencyAmount, shouldShowInvestmentFlowButtons, Modal, InitialAvatarIcon, Heading, BaseText, ButtonBoxDecide, NebraskaColors }
}

})